/* eslint-disable camelcase */
const user_state = 'vpm-state';
const city_name = 'city_name';
const user_id = 'user_id';
const vendor_category = 'vendor_category';
const order_info = 'order_info';
const event_date = 'event_date';
const event_date_flexible = 'event_date_flexible';
const search_guests = 'search_guests';
/**
 * Loads state from storage
 */

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem(user_state);
    if (serializedState === null) {
      return null;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    return null;
  }
};
export const saveOrderInfo = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(order_info, serializedState);
    return true;
  } catch (error) {
    return false;
  }
};
export const loadOrderInfo = () => {
  try {
    const serializedState = localStorage.getItem(order_info);
    if (serializedState === null) {
      return null;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    return null;
  }
};
export const clearOrderInfo = () => {
  try {
    localStorage.removeItem(order_info);
    return true;
  } catch (error) {
    return false;
  }
};

export const saveState = state => {
  try {
    if (!state) {
      return false;
    }
    const { token: _token, ...profile } = state;
    const serializedState = JSON.stringify(profile);
    localStorage.setItem(user_state, serializedState);
    return true;
  } catch (error) {
    return false;
  }
};
export const userState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(user_id, serializedState);
    return true;
  } catch (error) {
    return false;
  }
};
export const clearUserState = () => {
  try {
    localStorage.removeItem(user_id);
    return true;
  } catch (error) {
    return false;
  }
};

export const cityState = state => {
  try {
    if (state) {
      localStorage.setItem(city_name, state);
    } else {
      localStorage.removeItem(city_name);
    }
    return true;
  } catch (error) {
    return false;
  }
};

export const loadCityState = () => {
  try {
    const serializedState = localStorage.getItem(city_name);
    if (serializedState === null) {
      return null;
    }
    return serializedState;
  } catch (error) {
    return null;
  }
};
export const saveVendorCategoryState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(vendor_category, serializedState);
    return true;
  } catch (error) {
    return false;
  }
};
export const loadVendorCategoryState = () => {
  try {
    const serializedState = localStorage.getItem(vendor_category);
    if (serializedState === null) {
      return null;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    return null;
  }
};
export const saveEventDateState = state => {
  try {
    if (state) {
      localStorage.setItem(event_date, state);
    } else {
      localStorage.removeItem(event_date);
    }
    return true;
  } catch (error) {
    return false;
  }
};

export const loadEventDateState = () => {
  try {
    return localStorage.getItem(event_date);
  } catch (error) {
    return null;
  }
};

/** Search “Flexible / Anytime” date mode (no specific date sent to API). */
export const saveEventDateFlexibleState = isFlexible => {
  try {
    if (isFlexible) {
      localStorage.setItem(event_date_flexible, '1');
      localStorage.removeItem(event_date);
    } else {
      localStorage.removeItem(event_date_flexible);
    }
    return true;
  } catch (error) {
    return false;
  }
};

export const loadEventDateFlexibleState = () => {
  try {
    return localStorage.getItem(event_date_flexible) === '1';
  } catch (error) {
    return false;
  }
};

/** Clear landing/search criteria without wiping auth or category prefs. */
export const clearSearchCriteriaState = () => {
  try {
    localStorage.removeItem(city_name);
    localStorage.removeItem(event_date);
    localStorage.removeItem(event_date_flexible);
    localStorage.removeItem(search_guests);
    return true;
  } catch (error) {
    return false;
  }
};

/** Persist guest count from landing/search so vendor booking cards can prefill. */
export const saveGuestsState = guests => {
  try {
    const count = Number(guests);
    if (Number.isFinite(count) && count > 0) {
      localStorage.setItem(search_guests, String(Math.floor(count)));
    } else {
      localStorage.removeItem(search_guests);
    }
    return true;
  } catch (error) {
    return false;
  }
};

export const loadGuestsState = () => {
  try {
    const raw = localStorage.getItem(search_guests);
    if (raw == null || raw === '') {
      return null;
    }
    const count = Number(raw);
    if (!Number.isFinite(count) || count <= 0) {
      return null;
    }
    return Math.floor(count);
  } catch (error) {
    return null;
  }
};

export const clearState = () => {
  try {
    localStorage.removeItem(user_state);
    localStorage.removeItem(city_name);
    localStorage.removeItem(vendor_category);
    localStorage.removeItem(event_date);
    localStorage.removeItem(search_guests);
    localStorage.removeItem('client-x-auth-token');
    localStorage.removeItem(order_info);
    return true;
  } catch (error) {
    return false;
  }
};

/** Remove pre-cookie session id storage (Authorization / encrypted token). */
export function purgeLegacyAuthStorage() {
  try {
    localStorage.removeItem('client-x-auth-token');
    return true;
  } catch (error) {
    return false;
  }
}

/** @deprecated Use purgeLegacyAuthStorage */
export const clearLegacyTokenStorage = purgeLegacyAuthStorage;
